import { FC, ReactNode, useEffect } from 'react'
import { stencil, useGetLicenseFeaturesQuery, useGetUsersPermissionsQuery } from 'react-common'
import { sessionTrackerInit } from 'apps-common'
import { useAuth } from '@/features/auth/useAuth'

const { SplashLoading } = stencil

function useInitApp() {
  const { isLoading: isPermissionsLoading } = useGetUsersPermissionsQuery()
  const { isLoading: licensedFeaturesLoading } = useGetLicenseFeaturesQuery()

  const { user, isLoading: isUserLoading } = useAuth()

  useEffect(() => {
    if (user) {
      sessionTrackerInit(user.id)
    }
  }, [user])

  return Boolean(user) && !isUserLoading && !isPermissionsLoading && !licensedFeaturesLoading
}

export const AppInit: FC<{ children?: ReactNode }> = ({ children }) => {
  const appIsReady = useInitApp()
  if (appIsReady) {
    return <>{children}</>
  }

  return <SplashLoading />
}
